import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

export default function QuantityStepper({ value, onChange, min = 1, size = "small", disabled = false }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
      <IconButton size={size} onClick={() => onChange(value - 1)} disabled={disabled || value <= min}>
        <Remove fontSize="small" />
      </IconButton>
      <Typography sx={{ px: 1.5, minWidth: 24, textAlign: "center" }}>{value}</Typography>
      <IconButton size={size} onClick={() => onChange(value + 1)} disabled={disabled}>
        <Add fontSize="small" />
      </IconButton>
    </Box>
  );
}
